import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	trialInfo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	standardTrialInfo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hasPaymentDetailsLegalText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	trialInfo: {
		id: 'project-directory-onboarding-modal.trial-info',
		defaultMessage:
			'Free 30-day Premium plan trial. Cancel or downgrade anytime. By selecting "Get started" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy</pp>.',
		description: 'Information about the free 30-day Premium plan trial and agreement terms',
	},
	standardTrialInfo: {
		id: 'project-directory-onboarding-modal.standard-trial-info',
		defaultMessage:
			'Free 14-day Standard plan trial. Cancel or downgrade anytime. By selecting "Get started" you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy</pp>.',
		description: 'Information about the free 14-day Standard plan trial and agreement terms',
	},
	hasPaymentDetailsLegalText: {
		id: 'project-directory-onboarding-modal.has-payment-details-legal-text',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			"If you don't cancel during the trial, subscription billing will begin and renew monthly based on <cp>current pricing</cp>. Cancel anytime.",
		description: 'Prompt legal text for users with saved payment details',
	},
});
export default messages;
